import { Button } from "@msuite/ui/button";
import { FileIcon } from "@msuite/ui/file-upload";
import { useLoading } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { toast } from "@msuite/ui/toast";
import { responseHandler } from "@msuite/ui/utils";
import type { PartnerTimelineReport } from "@msuite/utils/types";
import { client } from "@/hono";

/** Props Interface */
interface PartnerTimelineReportsGroupHeaderProps {
	group: PartnerTimelineReport;
}

export function PartnerTimelineReportsGroupHeader({
	group: report,
}: PartnerTimelineReportsGroupHeaderProps) {
	/** Context */
	const { t } = useTranslation();

	/** Hooks */
	const loader = useLoading();

	/** Functions */
	async function handleOpenReport() {
		try {
			loader.start();
			const response = await client.files[":fileId"].$get({
				param: { fileId: report.fileId },
			});
			const data = await responseHandler(response);
			if (!data.success) return;
			if (!data.signedUrl) return;
			window.open(data.signedUrl, "_blank");
		} catch (error) {
			console.error(error);
			toast.error(t("general.something_went_wrong"));
		} finally {
			loader.stop();
		}
	}

	/** Render */
	return (
		<div className="table-row sticky top-0 h-stack pr-3 -my-2 py-2">
			<div
				className="table-cell"
				style={{
					display: "grid",
					gridTemplateColumns: "max-content 1fr",
					alignItems: "center",
					gap: 4,
				}}
			>
				<FileIcon
					fileType="application/pdf"
					size={12}
				/>
				<p className="tabular-nums">{report.reportNumber}</p>
			</div>
			<div className="ml-auto">
				<Button
					variant="plain"
					icon={<Icon name="Eye" />}
					onClick={handleOpenReport}
					isDisabled={!report.fileId}
					isLoading={loader.isLoading}
				>
					{t("general.open")}
				</Button>
			</div>
		</div>
	);
}
